import React, { Component } from 'react'
import Chart from 'chart.js';

let myChart;

class HorasAulaPieChart extends Component {

  componentDidMount = () => {
    this.buildChart();
  };

  componentDidUpdate = () => {
    this.buildChart();
  };

  buildChart = () => {
    let element = document.getElementById("piechart-horasaula"),
      myChartRef = element.getContext("2d");

    element.height = this.props.heigth;

    if (typeof myChart !== "undefined") myChart.destroy();

    let unidades = this.props.unidades.slice();
    unidades = unidades.filter(a => a.horasAula.total > 0);

    myChart = new Chart(myChartRef, {
      type: 'doughnut',
      data: {
        labels: unidades.map(u => u.unidade),
        datasets: [
          {
            data: unidades.map(u => u.horasAula.total),
            backgroundColor: unidades.map(u => u.color),
            datalabels: {
              color: 'rgba(0, 0, 0, 1)',
              anchor: 'end',
              align: 'start',
              formatter: function (value, context) {
                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                return Math.round((value/total) * 100) + '%';
              }
            }
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Horas Aula / Unidade',
          fontSize: 14
        },
        legend: {
          position: 'bottom',
          labels: { padding: 5, boxWidth: 20 }
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: -10,
            bottom: -10
          }
        },
        maintainAspectRatio: false
      }
    });
  };

  render() {
    return (
      <canvas id="piechart-horasaula" />
    )
  }
}

export default HorasAulaPieChart;